module.exports = __webpack_public_path__ + "img/37646748000176.e32f4d51.png";